import { socialLinksStyles } from "@waytek/Overrides/Widgets/Basic/SocialLinks";
import { css } from "styled-components";

socialLinksStyles.socialLinkListWrapper = {
    ...socialLinksStyles.socialLinkListWrapper,
    css: css`
        display: flex;
        flex-wrap: wrap;
        margin-top: 25px;
    `,
};

socialLinksStyles.linkWrapper = {
    ...socialLinksStyles.linkWrapper,
    css: css`
        padding: 0;
        margin-right: 0;
        flex-grow: 0;
    `,
};

socialLinksStyles.link = {
    ...socialLinksStyles.link,
    css: css`
        padding: 0;
        margin: 0;

        span {
            margin: 0;
            padding: 0;
        }
    `,
};
